import { useEffect, useState } from "react";
import Script from "next/script";
import { Container } from "src/components-mui/layout/container";
import { JobsWidgetSkeleton } from "./jobs-widget-skeleton";

const WIDGET_ADDRESS = "https://wikifolio.onlyfy.jobs";

export interface IJobsWidgetModuleProps {
    widgetUrl: string;
}

export const JobsWidgetModule = ({ widgetUrl }: IJobsWidgetModuleProps) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const handleIframeMessage = (event: MessageEvent) => {
            const { data, origin } = event;

            if (origin !== WIDGET_ADDRESS) {
                return;
            }

            if (typeof data === "object" && data !== null && Object.keys(data).length > 0) {
                setIsLoading(false);
            }
        };

        window.addEventListener("message", handleIframeMessage);

        return () => {
            window.removeEventListener("message", handleIframeMessage);
        };
    }, []);

    return (
        <Container>
            {isLoading && <JobsWidgetSkeleton />}
            <div id="psJobWidget" style={{ visibility: isLoading ? "hidden" : "visible" }} />
            <Script src={widgetUrl} strategy="lazyOnload" />
        </Container>
    );
};
